import React from "react";
import VideoDepressao from '../../videos/ansiedade-depressao.mp4';
import imgBullying from '../../imgs/Bullying.jpeg';
import imgTelas from '../../imgs/historia-quadrinho-2.jpeg';
import cerebroVideo from '../../imgs/saude-geral/cerebro.mp4';
import { useIsMobile } from "../../hooks/useIsMobile";
import posterDepressao from '../../imgs/poster-videos/lucas-depressao.png';

export default function SaudeEmocional() {
    const isMobile = useIsMobile();

    const mediaStyle = {
        width: isMobile ? '100%' : 600,
        maxWidth: '100%',
        height: 'auto'
    };

    const videoStyle = {
        width: isMobile ? '100%' : 800,
        height: isMobile ? 'auto' : 460,
        maxWidth: '100%'
    };

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 40
    };

    return (
        <div style={{ paddingTop: 60, paddingBottom: 60 }}>
            <h1 style={{ textAlign: 'center' }}>Saúde Emocional</h1>
            <div className="container">
                <h2 style={{ textAlign: 'center' }}>Ansiedade</h2>

                {isMobile ? (
                    <>
                        <p>Sentir ansiedade às vezes é normal, mas quando se torna constante e atrapalha a rotina, é preciso ficar atento (a).</p>

                        <p>Ela pode causar sintomas como coração acelerado, tensão e insônia.</p>
                        <p>Procurar ajuda, conversar com alguém e praticar atividades relaxantes são atitudes de coragem e cuidado com a saúde mental.</p>

                    </>
                ) : (
                    <>
                        <p>Sentir ansiedade de vez em quando é normal — tipo antes de uma prova ou de algo importante. Mas quando essa sensação vira rotina e atrapalha o sono, a concentração ou até o bem-estar, é sinal de alerta. A ansiedade pode causar sintomas como coração acelerado, suor nas mãos, tensão no corpo e dificuldade para dormir. Falar com alguém de confiança, procurar um psicólogo e incluir atividades que ajudem a relaxar, como esporte, música ou meditação, fazem toda a diferença. Lembrando: pedir ajuda não é sinal de fraqueza, é um passo de coragem e autocuidado.</p>

                    </>
                )}

                <h2 style={{ textAlign: 'center' }}>Depressão</h2>
                {isMobile ? (
                    <>
                        <p>
                            A depressão é um transtorno sério que afeta pensamentos, emoções e a rotina da pessoa. Os sintomas incluem desânimo, falta de interesse, insônia e baixa autoestima.
                        </p>
                        <p>
                            Buscar ajuda profissional e apoio de pessoas próximas é essencial para a recuperação.
                        </p>
                    </>
                ) : (
                    <>
                        <p> A depressão vai muito além de estar triste. É um transtorno sério que afeta o jeito de pensar, sentir e viver o dia a dia. Quem está passando por isso pode perder o interesse nas coisas que gostava, se sentir sem energia, com baixa autoestima, dificuldade para dormir ou comer. O tratamento envolve psicólogo, às vezes psiquiatra e, em alguns casos, remédios. Ter uma rotina saudável, fazer atividades prazerosas e contar com o apoio de quem se importa ajuda — e muito! Falar sobre o que sente e buscar ajuda é o primeiro passo para se recuperar.</p>

                    </>
                )}

                <h2 style={{ textAlign: 'center' }}>Vamos conhecer a história de Lucas e como ele superou?</h2>

                <div style={containerStyle}>
                    <video
                        style={videoStyle}
                        controls
                        {...(isMobile ? { poster: posterDepressao } : {})}
                    >
                        <source src={VideoDepressao} type="video/mp4" />
                        Seu navegador não suporta a tag de vídeo.
                    </video>

                </div>

                <h2 style={{ textAlign: 'center' }}>Transtornos alimentares</h2>
                {isMobile ? (
                    <>
                        <p>Transtornos alimentares, como anorexia, bulimia e compulsão, afetam o corpo e a mente, causando sérios prejuízos à saúde. Eles envolvem sofrimento emocional, baixa autoestima e riscos como desnutrição e problemas hormonais.</p>
                    </>
                ): (

                <p>Quando a relação com a comida e o próprio corpo vira um problema, é hora de ligar o sinal de alerta. Transtornos alimentares, como anorexia, bulimia e compulsão alimentar, afetam a saúde física e emocional. Além dos riscos para o corpo, como desnutrição e problemas hormonais, esses transtornos mexem com a autoestima e podem causar muito sofrimento. A ajuda de profissionais, como psicólogo e nutricionista, é fundamental. E o apoio da família e dos amigos também faz toda a diferença. Ninguém precisa passar por isso sozinho.</p>
                )}

                <h2 style={{ textAlign: 'center' }}>Bullying</h2>
                {isMobile ? (
                    <>
                        <p>Bullying não é brincadeira, é violência que machuca e afeta a saúde emocional. Quem sofre pode se sentir triste, inseguro e isolado. Por isso, é importante respeitar os outros, conversar com adultos de confiança e buscar ajuda quando precisar.</p>
                    </>
                ):(
                    <p> Bullying não é “brincadeira” — é uma forma de violência que machuca de verdade. Pode ser física, verbal ou pela internet, e afeta diretamente a saúde emocional. Quem sofre bullying pode se sentir triste, isolado, inseguro e até ter sintomas de depressão ou ansiedade. Por isso, é essencial conversar com um adulto de confiança, com a escola e buscar apoio psicológico, se necessário. Prevenir o bullying começa com respeito e empatia: todo mundo tem o direito de ser quem é, sem medo.</p>

                )}

                <h2 style={{ textAlign: 'center' }}>Vamos conhecer o recomeço de Isadora?</h2>
                <div style={containerStyle}>
                    <img src={imgBullying} alt="passo1img" style={mediaStyle} />
                </div>

                <h2 style={{ textAlign: 'center' }}>Uso excessivo das telas</h2>
                {isMobile ? (
                    <>
                        <p>Passar muito tempo em frente às telas pode causar cansaço, dificuldade para dormir e atrapalhar a concentração. O uso excessivo ainda pode afastar amigos e família, além de deixar a pessoa sedentária. Além disso, a dependência das telas acontece porque elas liberam dopamina, que gera prazer e vontade de ficar cada vez mais conectados.</p>
                    </>
                ):(
                    <>
                    <p>
                    Hoje em dia, a gente passa muito tempo em frente às telas — celular, computador, tablet, TV... E, claro, a tecnologia faz parte da nossa vida: estudar, conversar com os amigos, jogar, assistir a vídeos, tudo isso acontece por meio delas. Mas quando o uso das telas é exagerado, pode acabar fazendo mal para nossa saúde.
                </p>
                <p>
                    Ficar muitas horas seguidas em frente às telas pode causar dores de cabeça, cansaço nos olhos, problemas para dormir, além de atrapalhar a concentração nos estudos e até afastar da convivência com a família e os amigos de verdade. Também pode deixar mais sedentário, o que não é bom para o corpo nem para a mente.
                </p>
                <p>
                    Além disso, o uso excessivo de telas e videogames funciona como uma droga, pois estimula a liberação de dopamina, uma substância ligada à sensação de prazer. Isso faz com que a gente queira passar cada vez mais tempo conectado, o que pode gerar dependência e dificuldade em se desligar.
                </p>

                    </>

                )}
                
                <div style={containerStyle}>
                    <video style={videoStyle} controls muted autoPlay >
                        <source src={cerebroVideo} type="video/mp4" />
                        Seu navegador não suporta a tag de vídeo.
                    </video>
                </div>

                <p>
                    Por isso, é importante ficar de olho no tempo que passamos conectados. Que tal fazer pausas durante o uso, evitar o celular antes de dormir e reservar um tempinho para atividades fora da tela, como ler um livro, praticar esportes ou simplesmente conversar com alguém?
                </p>
                <p>
                    <span className="atencao" style={{ fontSize: 18 }}>Usar a tecnologia com equilíbrio é o segredo!</span> A ideia não é parar de usar, mas usar de forma consciente e saudável. Seu corpo e sua mente agradecem
                </p>

                <h3 style={{ textAlign: 'center' }}>Vamos conhecer a história do Pedro?</h3>
                <div style={containerStyle}>
                    <img src={imgTelas} alt="passo1img" style={{ ...mediaStyle }} />
                </div>

                <p style={{ marginBottom: 120, fontSize: 24, fontweight: 'bold', textAlign: 'center' }}>Se você estiver passando por algum problema desses, procure a Unidade Básica de Saúde (UBS ou UBSF) mais próxima do seu bairro e peça ajuda para algum profissional. A equipe de saúde está lá para te ajudar.</p>
            </div>
        </div>
    );
}
